import React, { PureComponent } from "react";
import _ from "lodash";
import { ContentOwnersStyle } from "../styles/ContentOwnersStyle";
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  WithStyles,
  withStyles,
  Button,
  TableHead,
  Grid,
  Link,
  TextField,
} from "@material-ui/core";
import {
  dateService,
  MyPATDialog,
  MyPATSelect,
  MyPATTextArea,
  MyPATTextField,
} from "../../common";
import { extractContent, onlyAllowNumbers } from "../../../utils";
import { ContentSubType } from "../../test-template/types/ContentSubTypeBody";
import InputViaDialog from "../common/InputViaDialog";
import AddConceptOrChapter from "../../mylibrary/components/ContentCreate/AddConceptOrChapter";
import CustomInfoIcon from "../../common/CustomInfoIcon";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { ContentRequest, Owners, Question } from "../types/ContentRequest";
import MyPATTab from "../../common/MyPATTab";
import MyPATTabs from "../../common/MyPATTabs";

interface Props extends WithStyles<typeof ContentOwnersStyle> {
  content: any,
  totalOwners: number,
  totalQuestions: number,
  creator: string,
  creatorEndDate: string,
  evaluator: string,
  evaluatorEndDate: string,
  langEvaluator: string,
  langEvaluatorEndDate: string,
  moderator: string,
  moderatorEndDate: string,
  publisher: string,
  publisherEndDate: string,
  testType: string,
  totalTest: number,
  subjectAndQuestionsTabs: any,
  additionalDescription: string,
  isTestCompilationDetails?:boolean,
  contentRequest: ContentRequest
}
interface State {
  ownerLength: number,
  creationDate: string,
  evalutionDate: string,
  languageEvaluatorDate: string,
  moderatorDate: string,
  publisherDate: string
}

class CreateOwnerDealine extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      ownerLength: 0,
      creationDate: '',
      evalutionDate: '',
      languageEvaluatorDate: '',
      moderatorDate: '',
      publisherDate: ''
    };
  }

  getTestAuthorDeadline = (authorType: string) => {
    const { contentRequest } = this.props;
    if(!contentRequest || _.isEmpty(contentRequest)) {
      return 'NA'
    }
    const owners: Owners[] = _.get(contentRequest, 'requestInfo.owners', [])
    const testOwner = owners.find(owner => owner.type === 'test-compiler');
    const author = _.get(testOwner, `roles[${authorType}]`, {});
    if(author.endDate) {
      return dateService.dateFromString(author.endDate);
    }
    return 'NA'
  }

  render() {
    const {
      classes,
      totalOwners,
      totalQuestions,
      creatorEndDate,
      evaluatorEndDate,
      langEvaluatorEndDate,
      moderatorEndDate,
      publisherEndDate,
      testType,
      totalTest,
      creator,
      evaluator,
      langEvaluator,
      moderator,
      publisher,
      subjectAndQuestionsTabs,
      additionalDescription,
      isTestCompilationDetails,
    } = this.props;
  
    return (
      <>
        {/* Subjectwise Content owners Details */}
        <Grid className={[classes.whiteCard, classes.borderR8].join(' ')}>
          <Grid
            container
            justify="space-between"
            alignItems="center"
            className={classes.borderBottom}
          >
            <Grid item>
              <Typography className={classes.subHeading}>
                Subject-wise Content owners Details
              </Typography>
            </Grid>
            <Grid item>
              <Grid container alignItems="center">
                <Grid item>
                  <Typography className={classes.rightText}>
                    Total Owners <span>: {totalOwners || 'N/A'}</span>
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.rightText}>
                    Total Question <span>: {totalQuestions || 'N/A'}</span>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container justify="flex-start" alignItems="center">
            <Grid item xs={12}>{subjectAndQuestionsTabs}</Grid>
            <Grid item xs={12}>
              <Typography className={classes.subHeading}>
                Deadlines for Content Creation
            </Typography>
              <Grid
                container
                justify="space-between"
                alignItems="center"
                className={classes.deadline}
              >
                <Grid item>
                  <Typography className={classes.mainText}>
                    Creation:
                  <span className={classes.subText}>{creatorEndDate || 'N/A'}</span>
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.mainText}>
                    Evaluation:
                  <span className={classes.subText}>{evaluatorEndDate || 'N/A'}</span>
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.mainText}>
                    Lang. Evaluation:
                  <span className={classes.subText}>{langEvaluatorEndDate || 'N/A'}</span>
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.mainText}>
                    Moderation:
                  <span className={classes.subText}>{moderatorEndDate || 'N/A'}</span>
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.mainText}>
                    Publish Content:
                  <span className={classes.subText}>{publisherEndDate || 'N/A'}</span>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          

          {/* Deadlines for Content Creation */}
        </Grid>
        {/* Test Compilation Details */}
        {
          isTestCompilationDetails&&
          <Grid className={[classes.whiteCard, classes.borderR8].join(' ')}>
          <Grid
            container
            justify="space-between"
            alignItems="center"
            className={classes.borderBottom}
          >
            <Grid item>
              <Typography className={classes.subHeading}>
                Test Compilation Details
              </Typography>
            </Grid>
            <Grid item>
              <Grid container>
                <Grid item>
                  <Typography className={classes.rightText}>
                    Type: <span>{testType || 'N/A'}</span>
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className={classes.rightText}>
                    Total Test: <span>{totalTest || 'N/A'}</span>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container>
            <Grid
              container
              justify="space-between"
              className={[classes.deadline, classes.border0].join(' ')}
            >
              <Grid item>
                <Typography className={[classes.mainText, classes.mb15].join(' ')}>
                  Creator:
                  <span className={classes.subText}>{creator || 'N/A'}</span>
                </Typography>
                <Typography className={classes.mainText}>
                  Deadline:
                  <span className={classes.subText}>{this.getTestAuthorDeadline('creator')}</span>
                </Typography>
              </Grid>
              <Grid item>
                <Typography className={[classes.mainText, classes.mb15].join(' ')}>
                  Evaluator:
                  <span className={classes.subText}>{evaluator || 'N/A'}</span>
                </Typography>
                <Typography className={classes.mainText}>
                  Deadline:
                  <span className={classes.subText}>{this.getTestAuthorDeadline('evaluator')}</span>
                </Typography>
              </Grid>
              <Grid item>
                <Typography className={[classes.mainText, classes.mb15].join(' ')}>
                  L. Evaluator:
                  <span className={classes.subText}>{langEvaluator || 'N/A'}</span>
                </Typography>
                <Typography className={classes.mainText}>
                  Deadline:
                  <span className={classes.subText}>{this.getTestAuthorDeadline('languageEvaluator')}</span>
                </Typography>
              </Grid>
              <Grid item>
                <Typography className={[classes.mainText, classes.mb15].join(' ')}>
                  Moderator:
                  <span className={classes.subText}>{moderator || 'N/A'}</span>
                </Typography>
                <Typography className={classes.mainText}>
                  Deadline:
                  <span className={classes.subText}>{this.getTestAuthorDeadline('moderator')}</span>
                </Typography>
              </Grid>
              <Grid item>
                <Typography className={[classes.mainText, classes.mb15].join(' ')}>
                  Publisher:
                  <span className={classes.subText}>{publisher || 'N/A'}</span>
                </Typography>
                <Typography className={classes.mainText}>
                  Deadline:
                  <span className={classes.subText}>{this.getTestAuthorDeadline('publisher')}</span>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid container className={classes.additionalDesc}>
            <Typography dangerouslySetInnerHTML={{ __html: `Additional Description: ${additionalDescription}` }}>
              {/* Additional Description: <span>{additionalDescription}</span> */}
            </Typography>
          </Grid>
        </Grid>
     
        }
       </>
    );
  }
}
// @ts-ignore
export default withStyles(ContentOwnersStyle)(CreateOwnerDealine);
